import React from 'react';
import dash_api from '../../../main/support/dash_api';
import { BranchLoader } from '../core';

class Policies extends React.Component {
  constructor(props) {
    super(props);
    dash_api
      .get('/v1/policies')
      .then(({ data }) => {
        this.setState({ policies: data, loading: false });
      })
      .catch(() => this.setState({ loading: false }));

    this.state = {
      policies: null,
      loading: true,
    };
  }
  render() {
    if (this.state.loading) {
      return <BranchLoader size="medium" />;
    }
    return (
      <div>
        <div dangerouslySetInnerHTML={{ __html: this.state.policies }} />
      </div>
    );
  }
}

export default Policies;
